export default {
  impersonates: {
    breadcrumbsTitle: 'Impersonate',
  },
};
